import { jsx as _jsx } from "react/jsx-runtime";
import { StaffFallback } from '../Fallbacks';
import { SafeImageViewFallback } from '../SafeImageView';
import { Box } from "@kolmeo/ui-core";
const UserImage = ({ imageUrl, width, height, userTypeId, ...props }) => {
    return (_jsx(Box, { ...props, children: _jsx(SafeImageViewFallback, { image: { uri: imageUrl ?? undefined }, style: { width: width, height: height, borderRadius: 500 }, fallbackView: _jsx(StaffFallback, { width: width, height: height, style: { marginRight: 4 }, userTypeId: userTypeId }) }) }));
};
export default UserImage;
